/** Excel + print-to-PDF helpers for Reports module. */
import * as XLSX from 'xlsx';

export function downloadExcelBlob(data, filename) {
  if (!data?.length) return false;
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Report');
  const name = filename.toLowerCase().endsWith('.xlsx') ? filename : `${filename.replace(/\.csv$/i, '')}.xlsx`;
  XLSX.writeFile(wb, name);
  return true;
}

export function printReportPdf(data, title) {
  if (!data?.length) return false;
  const headers = Object.keys(data[0]);
  const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const bodyRows = data.map(r =>
    `<tr>${headers.map(h => `<td>${esc(r[h])}</td>`).join("")}</tr>`,
  ).join("");
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${esc(title)}</title>
<style>
  @media print { @page { margin: 12mm; } }
  body { font-family: Arial, Helvetica, sans-serif; padding: 20px; color: #111; }
  h1 { font-size: 18px; margin: 0 0 4px; color: #0B2545; }
  .meta { font-size: 11px; color: #666; margin-bottom: 16px; }
  table { width: 100%; border-collapse: collapse; font-size: 10px; }
  th, td { border: 1px solid #ddd; padding: 5px 7px; text-align: left; vertical-align: top; }
  th { background: #0B2545; color: #fff; }
  tr:nth-child(even) { background: #f9f9f9; }
</style></head><body>
<h1>${esc(title)}</h1>
<div class="meta">Founders Bridge · ${esc(new Date().toLocaleString("en-IN"))} · ${data.length} row${data.length !== 1 ? "s" : ""}</div>
<table><thead><tr>${headers.map(h => `<th>${esc(h)}</th>`).join("")}</tr></thead>
<tbody>${bodyRows}</tbody></table>
<script>window.onload=function(){window.print();}</script>
</body></html>`;
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  return true;
}

if (typeof process !== "undefined" && process.env?.NODE_ENV === "test") {
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet([{ a: 1, b: "x" }]), 'Report');
  console.assert(XLSX.write(wb, { type: 'array', bookType: 'xlsx' }).byteLength > 0, 'xlsx export should produce bytes');
}
